<template>
  <div v-show="menuActive" class="account-menu">
    <div class="menu-backdrop" @click="closeMenu" @contextmenu.prevent />
    <div id="menu" class="menu" @click="closeMenu">
      <div class="info">Zalogowany jako: {{ username }}</div>
      <div class="horizontal-line" />
      <button @click="setHome">
        <div class="icon md-icon">home</div>
        Ustaw jako domyślny widok
      </button>
      <button @click="$router.push('/settings/1')">
        <div class="icon md-icon">settings</div>
        Ustawienia
      </button>
      <button v-if="loggedIn" @click="logout">
        <div class="icon md-icon">logout</div>
        Wyloguj
      </button>
      <div class="horizontal-line" />
    </div>
  </div>
</template>

<style scoped>
.menu-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  background: var(--bg-color-hover);
}
.menu {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 15;
  border-radius: var(--rounding-smaller);
  background-color: var(--bg-color-card-default);
  border: var(--menu-border);
  display: flex;
  flex-flow: column nowrap;
}
.info {
  padding: 4px 8px;
  font-size: var(--text-size-tertiary);
  font-weight: 400;
  opacity: var(--text-opacity-tertiary);
}

.horizontal-line {
  width: 100%;
  height: 1px;
  background-color: rgba(0, 0, 0, 0.2);
}
button {
  height: var(--indent-size);
  min-width: 150px;
  display: flex;
  align-items: center;
  border: none;
  background-color: transparent;
  cursor: pointer;
}
button:hover {
  background: var(--bg-color-hover);
}
.icon {
  flex: var(--indent-size) 0 0;
  margin: 0;
}
</style>

<script>
import Vue from "vue";
import settings from "@/synced-settings";

export default {
  data() {
    return {
      menuActive: false,
    };
  },
  computed: {
    loggedIn() {
      return !!this?.$sessionState?.loggedInAs;
    },
    username() {
      return this?.$sessionState?.loggedInAs ?? "anonymous user";
    },
  },
  methods: {
    logout() {
      Vue.logout();
    },
    openMenu() {
      this.menuActive = true;
    },
    closeMenu() {
      this.menuActive = false;
      // FIXME deduplicate (condition for floating sidebar)
      if (this.$root.isMobile || this.windowWidth < 920) {
        this.$root.showSidebar = false;
      }
    },
    setHome() {
      if (this.$router.currentRoute.name === "day") {
        settings.homeView = "/day/current";
      } else if (this.$router.currentRoute.name === "week") {
        settings.homeView = "/week/current";
      } else {
        settings.homeView = this.$router.currentRoute.path;
      }
    },
  },
  mounted() {
    this.$root.$on("account-menu", (data) => {
      this.openMenu();
    });
  },
};
</script>
